/* eslint-disable import/no-unresolved */
import { getToken } from '@config/recaptcha';

const NEWSLETTER_ENDPOINT_URL = '/wp-json/azds/v1/newsletter/subscribe';

function initNewsletter(rootEl) {
  if (!rootEl) {
    return;
  }

  const content = rootEl.querySelector('[data-newsletter-content]');
  const formState = rootEl.querySelector('[data-newsletter-form-state]');
  const successState = rootEl.querySelector('[data-newsletter-success-state]');
  const form = rootEl.querySelector('[data-newsletter-form]');
  const message = rootEl.querySelector('[data-newsletter-message]');
  const submitButton = form ? form.querySelector('button[type="submit"]') : null;

  if (!content || !formState || !successState || !form) {
    return;
  }

  form.reset();

  const submittedButton = successState.querySelector('button');

  function lockHeight() {
    const height = Math.ceil(content.getBoundingClientRect().height);
    rootEl.style.setProperty('--newsletter-fixed-height', `${height}px`);
  }

  function showSuccess() {
    lockHeight();
    rootEl.classList.add('is-success');
    formState.hidden = true;
    successState.hidden = false;

    if (submittedButton) {
      submittedButton.focus({ preventScroll: true });
    }

    form.dispatchEvent(new CustomEvent('newslettersuccess'));
  }

  function setMessage(text) {
    if (!message) {
      return;
    }

    message.textContent = text;
    message.hidden = !text;
  }

  function setSubmitting(isSubmitting) {
    if (submitButton) {
      submitButton.disabled = isSubmitting;
    }

    if (isSubmitting) {
      form.setAttribute('aria-busy', 'true');
    } else {
      form.removeAttribute('aria-busy');
    }
  }

  async function submitNewsletter(payload) {
    const response = await fetch(NEWSLETTER_ENDPOINT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let errorText = 'Request failed';
      const responseData = await response.json().catch(() => null);
      if (responseData && typeof responseData.message === 'string' && responseData.message) {
        errorText = responseData.message;
      }
      throw new Error(errorText);
    }

    return response.json().catch(() => ({}));
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    setMessage('');

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(form);
    const firstName = String(formData.get('firstName') || '').trim();
    const lastName = String(formData.get('lastName') || '').trim();
    const email = String(formData.get('email') || '').trim();

    if (!firstName || !lastName || !email) {
      setMessage('Please complete all required fields.');
      return;
    }

    setSubmitting(true);

    const tokenKey = rootEl.dataset.tokenKey || 'newsletter';
    const recaptchaSiteKey = String(rootEl.dataset.recaptchaSiteKey || '').trim();

    if (!recaptchaSiteKey) {
      setMessage('Security check could not load. Please try again.');
      setSubmitting(false);
      return;
    }

    let recaptchaToken = '';
    try {
      recaptchaToken = await getToken(recaptchaSiteKey);
      if (!recaptchaToken) {
        setMessage('Security check failed. Please try again.');
        setSubmitting(false);
        return;
      }
    } catch {
      setMessage('Security check could not load. Please try again.');
      setSubmitting(false);
      return;
    }

    try {
      await submitNewsletter({
        firstName,
        lastName,
        email,
        tokenKey,
        recaptchaToken,
      });
      showSuccess();
    } catch (error) {
      if (error instanceof Error && error.message) {
        setMessage(error.message);
      } else {
        setMessage('Something went wrong, please try later.');
      }
    } finally {
      setSubmitting(false);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-newsletter', () => {
      document.querySelectorAll('.c-newsletter').forEach(initNewsletter);
    });
  } else {
    document.querySelectorAll('.c-newsletter').forEach(initNewsletter);
  }
});
